import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'qaroni-redirect-link',
  templateUrl: './redirect-link.component.html',
  styleUrl: './redirect-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RedirectLinkComponent {
  readonly route = input<string | string[] | null>(null);
  readonly text = input<string | null>(null);
}
